module.exports = __webpack_public_path__ + "img/HomePage.1c7dece7.png";